"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupSignupButonClicked = exports.setupSignupPricingPageViewed = exports.createTracker = void 0;
const tracker_1 = __importDefault(require("./tracker"));
function createTracker(apiKey, userId) {
    if (apiKey === null || apiKey === undefined || apiKey === "") {
        return null;
    }
    return new tracker_1.default(apiKey, userId);
}
exports.createTracker = createTracker;
function setupSignupPricingPageViewed(tracker) {
    if (!window.location.href.includes("/plans-and-pricing")) {
        return;
    }
    const planGroup = tracker.formatter.getCurrentPlanGroupData();
    if (planGroup === null) {
        return;
    }
    tracker.trackSignupPricingPageViewed(planGroup.getPlanGroupId(), planGroup.getPlanGroupName());
}
exports.setupSignupPricingPageViewed = setupSignupPricingPageViewed;
function setupSignupButonClicked(tracker) {
    $(".top .signup").on("click", function () {
        tracker.trackSignupButtonClicked("website-header");
    });
    // Signup box
    $(".nws-fr .btn").on("click", function () {
        tracker.trackSignupButtonClicked("email-signup-box");
    });
    // "Create your event" frontpage
    $(".bnr-cnt .btn-fs-bg").on("click", function () {
        tracker.trackSignupButtonClicked("solution-hero");
    });
    // Signup -> https://www.addevent.com/plans-and-pricing
    $(".prib.signedout .act .signup").on("click", function () {
        tracker.trackSignupButtonClicked("pricing-plan");
    });
    $(".prib.signedout .act .entsignup").on("click", function () {
        tracker.trackSignupButtonClicked("pricing-enterprise");
    });
    // Signup -> https://www.addevent.com/plans-and-pricing/details
    $(".vid .vid-cnt .vid-block .btn").on("click", function () {
        tracker.trackSignupButtonClicked("pricing-details");
    });
    // Signup -> on solution pages like -> https://www.addevent.com/solutions/collect-rsvp-events
    $(".bnr .bnr-cnt .s1 .btn-plc .btn").on("click", function () {
        tracker.trackSignupButtonClicked("solution-hero");
    });
    $(".cal .cal-cnt .bottom .btn-place .btn").on("click", function () {
        tracker.trackSignupButtonClicked("solution-middle");
    });
    $(".txtimg-grid .item .link .btn").on("click", function () {
        tracker.trackSignupButtonClicked("solution-middle");
    });
    // Documentation - "Add to Calendar" button page -> https://www.addevent.com/documentation/add-to-calendar-button
    $(".sgnbrk-t2 .bts .bt1").on("click", function () {
        tracker.trackSignupButtonClicked("solution-hero");
    });
    // Add to Calendar button page -> https://www.addevent.com/add-to-calendar-button
    $(".sec1 .ma .lft .pad .bt .btn").on("click", function () {
        tracker.trackSignupButtonClicked("solution-hero");
    });
    $(".sec3 .li .btn").on("click", function () {
        tracker.trackSignupButtonClicked("solution-middle");
    });
    // Sign in page -> clicking "Sign up"
    $(".usica-t1 .auto .pad .inp-t9 a").on("click", function () {
        tracker.trackSignupButtonClicked("signin-page");
    });
    // MailChimp - app - sign in/sign up page
    $(".wrap .box .hx-t2 .btn").on("click", function () {
        tracker.trackSignupButtonClicked("signin-page");
    });
}
exports.setupSignupButonClicked = setupSignupButonClicked;
